import { COLOR_WISE_USERFORM_RESET, CREATE_COLORWISE_USERFORM, CREATE_COLOR_WISE_PROGRAM_COST_FAILURE, CREATE_COLOR_WISE_PROGRAM_COST_REQUEST, CREATE_COLOR_WISE_PROGRAM_COST_SUCCESS, DELETE_COLOR_WISE_PROGRAM_COST_FAILURE, DELETE_COLOR_WISE_PROGRAM_COST_REQUEST, FETCH_COLORWISE_COST_COLOR_LIST_FAILURE, FETCH_COLORWISE_COST_COLOR_LIST_REQUEST, FETCH_COLORWISE_COST_COLOR_LIST_SUCCESS, FETCH_COLORWISE_COST_PROGRAM_LIST_FAILURE, FETCH_COLORWISE_COST_PROGRAM_LIST_REQUEST, FETCH_COLORWISE_COST_PROGRAM_LIST_SUCCESS, FETCH_COLOR_DETAIL_BY_PROGRAM_FAILURE, FETCH_COLOR_DETAIL_BY_PROGRAM_REQUEST, FETCH_COLOR_DETAIL_BY_PROGRAM_SUCCESS, FETCH_COLOR_WISE_PROGRAM_COST_DATA_FAILURE, FETCH_COLOR_WISE_PROGRAM_COST_DATA_REQUEST, FETCH_COLOR_WISE_PROGRAM_COST_DATA_SUCCESS, SET_COLOR_WISE_DETAIL_BY_PROGRAM_PRICE } from "./colorwiseCost.actionsType";



export const COLORWISE_COST = 'colorwiseCost';

let initialState = {
    loading: false,
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        fldFKProgramId: 0,
        fldFKColor: 0
    },
    programData: [],
    colorwiseData: [],
    colorwiseDetailByProgram: [],
    colorwiseprogramData: [],

}

export let colorwiseCostReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_COLORWISE_COST_PROGRAM_LIST_REQUEST:
        case FETCH_COLORWISE_COST_COLOR_LIST_REQUEST:
        case FETCH_COLOR_DETAIL_BY_PROGRAM_REQUEST:
        case CREATE_COLOR_WISE_PROGRAM_COST_REQUEST:
        case FETCH_COLOR_WISE_PROGRAM_COST_DATA_REQUEST:
        case DELETE_COLOR_WISE_PROGRAM_COST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_COLORWISE_COST_PROGRAM_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                programData: updatePayload
            }
        case FETCH_COLORWISE_COST_COLOR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                colorwiseData: updatePayload
            }
        case FETCH_COLOR_DETAIL_BY_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                colorwiseDetailByProgram: updatePayload?.Program
            }
        case CREATE_COLOR_WISE_PROGRAM_COST_SUCCESS:
            return {
                ...state,
                loading: false,
            }
        case FETCH_COLOR_WISE_PROGRAM_COST_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                colorwiseprogramData: updatePayload
            }
        case DELETE_COLOR_WISE_PROGRAM_COST_FAILURE:
            return {
                ...state,
                loading: false,

            }
        case CREATE_COLORWISE_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
            };
        case FETCH_COLORWISE_COST_PROGRAM_LIST_FAILURE:
        case FETCH_COLORWISE_COST_COLOR_LIST_FAILURE:
        case FETCH_COLOR_DETAIL_BY_PROGRAM_FAILURE:
        case CREATE_COLOR_WISE_PROGRAM_COST_FAILURE:
        case FETCH_COLOR_WISE_PROGRAM_COST_DATA_FAILURE:
        case DELETE_COLOR_WISE_PROGRAM_COST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        // case CREATE_USER_FORM_GATE_ENTRY:
        //     return {
        //         ...state,
        //         loading: false,
        //         userform: {
        //             ...state.userform,
        //             [payload.key]: payload.value
        //         },
        //     };

        case SET_COLOR_WISE_DETAIL_BY_PROGRAM_PRICE:
            return {
                ...state,
                loading: false,
                colorwiseDetailByProgram: payload
            };
        case COLOR_WISE_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKProgramId: 0,
                    fldFKColor: 0
                },
                colorwiseDetailByProgram: []
            }
        default:
            return state;
    }
}
